module.exports = __webpack_public_path__ + "static/img/powerdengpao.e6e81618.png";